function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#777",
      fillOpacity: 1
    },
    d: "M30.93 4.75a12.171 12.171 0 0 0-9.09 3.55c-3.113 3.122-3.524 6.852-2.102 10.4L6.586 31.851a6.316 6.316 0 0 0 8.934 8.93l13.148-13.15c3.547 1.419 7.277 1.013 10.39-2.105 3.34-3.336 4.325-8.117 2.989-12.316l-7.309 7.316-6.316-1.578-1.578-6.316 7.308-7.317a12.327 12.327 0 0 0-3.222-.566ZM11.05 33.156a3.16 3.16 0 1 1 .003 6.319 3.16 3.16 0 0 1-.002-6.319Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.75
    },
    cx: 34.516,
    cy: 34.625,
    r: 13.519
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.806 23.86c-6.105 0-11.055 4.949-11.055 11.054 0 6.106 4.95 11.051 11.055 11.051 6.105 0 11.05-4.945 11.05-11.05 0-6.106-4.945-11.055-11.05-11.055zm-3.16 6.316c.402 0 .808.156 1.117.465l2.043 2.04 2.04-2.04a1.58 1.58 0 0 1 2.233 2.23l-2.043 2.043 2.043 2.04a1.58 1.58 0 1 1-2.234 2.234l-2.039-2.043-2.043 2.043c-.309.309-.707.46-1.117.46a1.58 1.58 0 0 1-1.113-2.695l2.039-2.039-2.04-2.042a1.575 1.575 0 0 1 0-2.231 1.578 1.578 0 0 1 1.114-.465z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.99999994
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderMaintenance);
export default __webpack_public_path__ + "static/media/under-maintenance.6cbc820d4ddfbe94bf8480c319df1669.svg";
export { ForwardRef as ReactComponent };